import { useParams } from 'react-router-dom'
import { useState } from 'react'
import { Loader2, Stethoscope } from 'lucide-react'
import { createClient } from '@/lib/supabase/client'
import { aceitarConvite } from '@/services/identity'

/**
 * Aceite de convite de equipe. Fluxo:
 * 1) visitante cria conta (ou entra) com o e-mail convidado;
 * 2) RPC aceitar_convite vincula o usuário ao workspace.
 */
export default function ConvitePage() {
  const { token: conviteToken } = useParams<{ token: string }>()
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const [modo, setModo] = useState<'signup' | 'login'>('signup')
  const [erro, setErro] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  if (!conviteToken) return null

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    if (!conviteToken) return
    setErro(null)
    setBusy(true)
    const supabase = createClient()
    try {
      const auth = modo === 'signup'
        ? await supabase.auth.signUp({ email, password: senha })
        : await supabase.auth.signInWithPassword({ email, password: senha })
      if (auth.error) {
        setErro(modo === 'signup' ? auth.error.message : 'E-mail ou senha inválidos.')
        return
      }
      await aceitarConvite(conviteToken)
      window.location.href = '/'
    } catch (err) {
      setErro(err instanceof Error ? err.message : 'Convite inválido ou expirado.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="public-screen">
      <div className="card" style={{ width: '100%', maxWidth: 400, padding: '32px 28px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 20 }}>
          <div
            aria-hidden
            style={{
              width: 48, height: 48, borderRadius: 13, background: 'var(--primary)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', marginBottom: 10,
            }}
          >
            <Stethoscope size={24} />
          </div>
          <h1 style={{ fontSize: 19, fontWeight: 800, margin: 0 }}>Convite — Médico 360</h1>
          <p className="page-subtitle" style={{ margin: '4px 0 0', textAlign: 'center' }}>
            Você foi convidado para uma equipe. {modo === 'signup' ? 'Crie sua conta com o e-mail convidado.' : 'Entre com sua conta.'}
          </p>
        </div>

        <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <label className="field-label" htmlFor="email">E-mail</label>
            <input id="email" type="email" required autoComplete="email" className="field-input" value={email} onChange={e => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="field-label" htmlFor="senha">Senha</label>
            <input
              id="senha" type="password" required minLength={8}
              autoComplete={modo === 'signup' ? 'new-password' : 'current-password'}
              className="field-input" value={senha} onChange={e => setSenha(e.target.value)}
            />
          </div>

          {erro && <div className="field-error" role="alert">{erro}</div>}

          <button type="submit" className="btn-primary" disabled={busy}>
            {busy && <Loader2 size={16} style={{ animation: 'spin 1s linear infinite' }} aria-hidden />}
            {modo === 'signup' ? 'Criar conta e aceitar convite' : 'Entrar e aceitar convite'}
          </button>
        </form>

        <div style={{ marginTop: 16, textAlign: 'center' }}>
          <button
            type="button"
            onClick={() => { setModo(m => (m === 'signup' ? 'login' : 'signup')); setErro(null) }}
            style={{ background: 'none', border: 'none', color: 'var(--primary)', fontWeight: 600, fontSize: 13.5 }}
          >
            {modo === 'signup' ? 'Já tenho conta' : 'Ainda não tenho conta'}
          </button>
        </div>
      </div>
    </div>
  )
}
